"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const arrowup = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-arrowup` : '') + (description ? ` desc-arrowup` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-arrowup"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-arrowup"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1418 0.760676L12.0228 0.75061L11.9186 0.753641C11.8437 0.760608 11.7831 0.772545 11.7245 0.790115L11.611 0.832522L11.4954 0.893494C11.4267 0.937095 11.3762 0.977467 11.3298 1.02298L1.52984 10.648L1.44946 10.7384C1.15689 11.1246 1.19386 11.647 1.52984 11.977L1.62185 12.0559L1.73121 12.1256C2.10529 12.3317 2.56673 12.275 2.87014 11.977L11.049 3.943L11.05 22.3125L11.057 22.4229C11.1226 22.9028 11.5243 23.25 12 23.25L12.1106 23.2437C12.5824 23.1897 12.95 22.7942 12.95 22.3125L12.949 3.942L21.1298 11.977L21.2218 12.0559C21.6114 12.3406 22.1364 12.3048 22.4701 11.977C22.8433 11.6105 22.8433 11.0145 22.4701 10.648L12.6701 1.02298L12.5912 0.954104L12.4709 0.873748L12.3783 0.827576L12.2507 0.783573L12.1418 0.760676Z",
    fill: "inherit"
  }));
};
var _default = exports.default = arrowup;